import type { MutationHookOptions } from '@apollo/client'
import {
  UpdateTrainingClassDocument,
  UpdateTrainingClassMutation,
  UpdateTrainingClassMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingClassMutation,
  UpdateTrainingClassMutationVariables
>

export const useUpdateTrainingClass = (options?: Options) => {
  const [updateTrainingClass, { loading }] = useMutation(UpdateTrainingClassDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.updateTrainingsTrainingClass,
  })

  return {
    loading,
    update(variables: UpdateTrainingClassMutationVariables) {
      return updateTrainingClass({
        variables,
      })
    },
  }
}
